const ENV_URLS = {
  local: {
    permissions: 'https://api.develrc-app.optimizely.com/permissions',
    mono: 'https://develrc-app.optimizely.com/api/v1',
  },
  inte: {
    permissions: 'https://api.develrc-app.optimizely.com/permissions',
    mono: 'https://develrc-app.optimizely.com/api/v1',
  },
  prep: {
    permissions: 'https://api.rc-app.optimizely.com/permissions',
    mono: 'https://rc-app.optimizely.com/api/v1',
  },
  prod: {
    permissions: 'https://api.app.optimizely.com/permissions',
    mono: 'https://app.optimizely.com/api/v1',
  },
};

const env = process.env.REACT_APP_ENV ?? 'local';
const PERMISSIONS_API_URL = ENV_URLS[env].permissions;
const MONO_V1_API_URL = ENV_URLS[env].mono;

const createRequestUrl = (projectId, entityType, entityId, userId) =>
  `${PERMISSIONS_API_URL}/${
    userId ? `users/${userId}/` : ''
  }projects/${projectId}/${entityType}s${entityId ? `/${entityId}` : ''}`;

const createTeamRequestURL = (projectId, entityType, entityId, teamId) =>
  `${PERMISSIONS_API_URL}/${
    teamId ? `teams/${teamId}/` : ''
  }projects/${projectId}/${entityType}s${entityId ? `/${entityId}` : ''}`;

const teamsRequestUrl = (accountId, teamId) =>
  `${PERMISSIONS_API_URL}/accounts/${accountId}/teams${
    teamId ? `/${teamId}` : ''
  }`;

const getAccountUsersRequestUrl = (accountId) =>
  `${MONO_V1_API_URL}/accounts/${accountId}/user_roles`;

const queryParameters = {};
const headerParameters = {};

const validateRequestUrl = (url) => {
  if (!url) {
    throw new Error(
      'Required parameter requestParameters.url was null or undefined.',
    );
  }
};

const fetchUsers = async (projectId, entityType, entityId) => {
  try {
    const requestUrl = createRequestUrl(projectId, entityType, entityId);
    validateRequestUrl(requestUrl);

    const response = await fetch(requestUrl, {
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
};

const updateUserRole = async (
  accountId,
  projectId,
  entityType,
  entityId,
  entityKey,
  userId,
  userEmail,
  newRole,
) => {
  try {
    const requestUrl = createRequestUrl(projectId, entityType, entityId);
    validateRequestUrl(requestUrl);

    const bodyParameters = {
      operations: [
        {
          op: 'replace',
          path: `/users/${userId}/role`,
          value: newRole,
        },
      ],
      metadata: {
        account_id: accountId ? String(accountId) : null,
        entity_key: entityKey ? String(entityKey) : null,
      }
    };

    const response = await fetch(requestUrl, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(bodyParameters),
      credentials: 'include',
    });

    if (!response.ok) {
      const errorData = await response.json();
      // Throw the actual error message from the API
      throw new Error(errorData.detail || `HTTP error! status: ${response.status}`);
    }

    // segment event tracking on success [FSSDK-10273]
    document.dispatchEvent(
      new CustomEvent('OPTLY:granularPermissions:changed', {
        detail: { userEmail, projectId, entityType, entityId, newRole },
      }),
    );

    return await response.json();
  } catch (error) {
    throw error; // Re-throw the error to be caught by the component
  }
};

const updateTeamRole = async (
  accountId,
  projectId,
  entityType,
  entityId,
  entityKey,
  teamId,
  newRole,
) => {
  try {
    const requestUrl = createRequestUrl(projectId, entityType, entityId);
    validateRequestUrl(requestUrl);

    const bodyParameters = {
      operations: [
        {
          op: 'replace',
          path: `/teams/${teamId}/role`,
          value: newRole,
        },
      ],
      metadata: {
        account_id: accountId ? String(accountId) : null,
        entity_key: entityKey ? String(entityKey) : null,
      }
    };

    const response = await fetch(requestUrl, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(bodyParameters),
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // segment event tracking on success [FSSDK-10273]
    // document.dispatchEvent(
    //   new CustomEvent('OPTLY:granularPermissions:changed', {
    //     detail: { userEmail, projectId, entityType, entityId, newRole },
    //   }),
    // );

    return await response.json();
  } catch (error) {
    throw error;
  }
};

const fetchUserEntityPermission = async (projectId, entityType, userId) => {
  try {
    const requestUrl = createRequestUrl(projectId, entityType, '', userId);
    validateRequestUrl(requestUrl);

    const response = await fetch(requestUrl, {
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    return result.items;
  } catch (error) {
    throw error;
  }
};

const fetchTeams = async (accountId) => {
  try {
    const requestUrl = teamsRequestUrl(accountId);
    validateRequestUrl(requestUrl);

    const response = await fetch(requestUrl, {
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const result = await response.json();
    // const result = [
    //   {
    //     id: 1000,
    //     name: 'Experiments Marketing',
    //     description: 'Marketing team for experiments',
    //     account_id: 123,
    //     external_ref: 'exp-marketing',
    //     created: '2021-01-25T22:57:24.470970Z',
    //     last_updated: '2021-01-25T22:57:24.470970Z',
    //     members_count: 2,
    //   },
    //   {
    //     id: 1001,
    //     name: 'Experiments Engineering',
    //     description: 'Engineering team for experiments',
    //     account_id: 123,
    //     external_ref: 'exp-engineering',
    //     created: '2024-01-25T22:57:24.470970Z',
    //     last_updated: '2021-01-265T22:57:24.470970Z',
    //     members_count: 3,
    //   },
    // ];

    return result;
  } catch (error) {
    throw error;
  }
};

const createTeam = async (accountId, teamData) => {
  try {
    const requestUrl = teamsRequestUrl(accountId);
    validateRequestUrl(requestUrl);

    const response = await fetch(requestUrl, {
      method: 'POST',
      headers: {
        ...headerParameters,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(teamData),
      credentials: 'include',
    });

    if (!response.ok) {
      const errorData = await response.json();
      
      if (errorData.detail) {
        throw new Error(JSON.stringify(errorData.detail));
      } else {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    }
    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
};

const updateTeam = async (accountId, teamId, teamData) => {
  try {
    const requestUrl = teamsRequestUrl(accountId, teamId);
    validateRequestUrl(requestUrl);

    const response = await fetch(requestUrl, {
      method: 'PATCH',
      headers: {
        ...headerParameters,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(teamData),
      credentials: 'include',
    });

    if (!response.ok) {
      const errorData = await response.json();

      if (errorData.detail) {
        throw new Error(JSON.stringify(errorData.detail));
      } else {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    }
    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
};

const deleteTeam = async (accountId, teamId) => {
  try {
    const requestUrl = teamsRequestUrl(accountId, teamId);
    validateRequestUrl(requestUrl);

    const response = await fetch(requestUrl, {
      method: 'DELETE',
      headers: {
        ...headerParameters,
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
};

const fetchTeamEntityPermission = async (projectId, entityType, teamId) => {
  try {
    const requestUrl = createTeamRequestURL(projectId, entityType, '', teamId);
    validateRequestUrl(requestUrl);

    const response = await fetch(requestUrl, {
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    return result.items;
    // return [
    //           {
    //               "role": "admin",
    //               "id": 101722349110451,
    //               "key": "production",
    //               "name": "Production"
    //           },
    //           {
    //               "role": "admin",
    //               "id": 161722349110481,
    //               "key": "development",
    //               "name": "Development"
    //           }
    //       ]
  } catch (error) {
    throw error;
  }
};

const fetchTeamUsers = async (accountId, teamId) => {
  try {
    const requestUrl = teamsRequestUrl(accountId, teamId);
    validateRequestUrl(requestUrl);

    // eslint-disable-next-line no-unused-vars
    const response = await fetch(requestUrl, {
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    // const result = {
    //   id: 1000,
    //   name: 'Experiments Marketing',
    //   description: 'Marketing team for experiments',
    //   account_id: 123,
    //   external_ref: 'exp-marketing',
    //   created: '2021-01-25T22:57:24.470970Z',
    //   last_updated: '2021-01-26T22:57:24.470970Z',
    //   members_count: 2,
    //   members: [
    //     {
    //       user_id: 'uniq123',
    //       first_name: 'John',
    //       last_name: 'Doe',
    //       email: 'john@exp.com',
    //       enum_role_name: 'admin',
    //       created: '2021-01-27T22:57:24.470970Z',
    //     },
    //     {
    //       user_id: 'uniq124',
    //       first_name: 'Amy',
    //       last_name: 'Doe',
    //       email: 'amy@exp.com',
    //       enum_role_name: 'admin',
    //       created: '2021-01-27T22:57:24.470970Z',
    //     },
    //   ],
    // };
    return result;
  } catch (error) {
    throw error;
  }
};

const fetchAccountUsers = async (accountId) => {
  try {
    const requestUrl = getAccountUsersRequestUrl(accountId);
    validateRequestUrl(requestUrl);

    const response = await fetch(requestUrl, {
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    let result = await response.json();
    // exclude invited users (not accepted invitation yet)
    result = result.filter((item) => item.collaborator_status !== 'INVITED');
    return result;
  } catch (error) {
    throw error;
  }
};

export {
  fetchUsers,
  updateUserRole,
  updateTeamRole,
  fetchUserEntityPermission,
  fetchTeams,
  createTeam,
  updateTeam,
  deleteTeam,
  fetchTeamEntityPermission,
  fetchTeamUsers,
  fetchAccountUsers,
};
